module.exports = __webpack_public_path__ + "static/2@3x-0dcc1254672326749e52f90621cc1580.png";